// Store/api/uploadApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../customFetchBase";

export const uploadApi = createApi({
  reducerPath: "uploadApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API + "upload",
    prepareHeaders: (headers, { getState }) => {
      const token = getState().adminsSlice?.token;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    // Upload multiple files
    uploadMultipleFiles: builder.mutation({
      query: (fileArray) => {
        const formData = new FormData();

        fileArray.forEach((file) => {
          formData.append("files", file);
        });

        return {
          url: "/multi",
          method: "POST",
          body: formData,
        };
      },
    }),
  }),
});

// Export hooks
export const { useUploadMultipleFilesMutation } = uploadApi;
